import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ZillowReviews from "@/components/ZillowReviews";
import UnmatchedMarketing from "@/components/UnmatchedMarketing";
import SEOContent from "@/components/SEOContent";
import BottomCTA from "@/components/BottomCTA";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>What's Your Home Worth? | Free Instant Home Value | Chris Pierog</title>
        <meta name="description" content="Get an instant home value estimate plus local expert review. See what your home could sell for in Grays Harbor County, Pacific County, Aberdeen, Montesano, Ocean Shores and surrounding areas." />
        <meta name="keywords" content="home value, what is my home worth, sell my house, Grays Harbor real estate, Aberdeen WA homes, Montesano real estate, Ocean Shores homes for sale, Pacific County real estate, free home valuation" />
        <meta property="og:title" content="See What Your Home Could Sell For Today" />
        <meta property="og:description" content="Instant estimate now. Local expert review available. No obligation." />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="min-h-screen bg-[#f0efeb] flex flex-col" data-testid="landing-page">
        <Header />
        <main className="flex-1">
          {/* Primary Conversion Section */}
          <HeroSection />
          
          {/* Social Proof / Reviews */}
          <ZillowReviews />
          
          {/* Marketing Capabilities */}
          <UnmatchedMarketing />
          
          {/* SEO Content - How Values Work, Areas, About */}
          <SEOContent />
          
          {/* Secondary CTA */}
          <BottomCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}
